import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

export const useHolidayStore = defineStore("holidays", () => {
  const holidays = ref([]);
  const meta = ref(null);
  const isLoading = ref(false);

  const fetchHolidays = async (userId) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.get(`/api/users/${userId}/holidays`);

      holidays.value = response.data.data;
      meta.value = response.data.meta;
      return response.data.data;
    } catch (err) {
      throw err.response?.data?.message || "Failed to fetch holidays";
    } finally {
      isLoading.value = false;
    }
  };

  const addHoliday = async (userId, holidayData) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.post(
        `/api/users/${userId}/holidays`,
        holidayData,
      );
      holidays.value.push(response.data.data);
      console.log(holidays.value);
      return response.data.data;
    } catch (err) {
      throw err.response?.data?.message || "Failed to add holidays";
    } finally {
      isLoading.value = false;
    }
  };

  const updateHoliday = async (userId, holidayData) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.put(
        `/api/users/${userId}/holidays`,
        holidayData,
      );
      const index = holidays.value.findIndex(
        (holiday) => holiday.id === holidayData.id,
      );
      if (index !== -1) {
        holidays.value[index] = response.data.data;
      }
      return response.data.data;
    } catch (err) {
      throw err.response?.data?.message || "Failed to update holiday";
    } finally {
      isLoading.value = false;
    }
  };

  const deleteHoliday = async (userId, id) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      await axios.delete(`/api/users/${userId}/holidays/${id}`);
      holidays.value = holidays.value.filter((holiday) => holiday.id !== id);
      return true;
    } catch (err) {
      throw err.response?.data?.message || "Failed to delete holiday";
    } finally {
      isLoading.value = false;
    }
  };

  return {
    holidays,
    meta,
    isLoading,
    fetchHolidays,
    addHoliday,
    updateHoliday,
    deleteHoliday,
  };
});
